import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=626e5068&"
import script from "./Services.vue?vue&type=script&lang=js&"
export * from "./Services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('626e5068')) {
      api.createRecord('626e5068', component.options)
    } else {
      api.reload('626e5068', component.options)
    }
    module.hot.accept("./Services.vue?vue&type=template&id=626e5068&", function () {
      api.rerender('626e5068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration/Services/Services.vue"
export default component.exports